import script from "./MainLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainLayout.vue?vue&type=script&setup=true&lang=ts"

import "./MainLayout.vue?vue&type=style&index=0&id=5aa68f4b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aa68f4b"]])

export default __exports__